/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';

import PermitVenuePage from '../src/containers/PermitVenuePage';
import PermitRegistrationPage from '../src/containers/PermitRegistrationPage';
import LotteryRegistrationPage from '../src/containers/LotteryRegistrationPage';
import LotteryWinnerConfirmationPage from '../src/containers/LotteryWinnerConfirmationPage';
import DetailedAvailabilityConductor from '../src/containers/DetailedAvailabilityConductor';
import AlternatePermitHolderConfirmationPage from '../src/containers/AlternatePermitHolderConfirmationPage';
import TertiaryContentPage from '../src/containers/TertiaryContentPage';
import CartlessConfirmationPage from '../src/containers/CartlessConfirmationPage';
import LotterySchedulePage from '../src/containers/LotterySchedulePage';
import MobileRedirector from '../src/containers/MobileRedirector';

import routesArray from './routesArray';

const Components = {
    PermitVenuePage,
    PermitRegistrationPage,
    LotteryRegistrationPage,
    LotteryWinnerConfirmationPage,
    DetailedAvailabilityConductor,
    AlternatePermitHolderConfirmationPage,
    TertiaryContentPage,
    CartlessConfirmationPage,
    LotterySchedulePage,
    MobileRedirector,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
